import { find, get } from 'lodash'

const regSpit = /\//g
const regIndex = /\.(\d+)/g
const regItems = /(\[\d+\])/g
const regProperties = /(\.)/g

export default function localize (errors = [], customErrors = [], schema/* , schemaPathMap */, ajv) {
  if (!errors.length) {
    return
  }

  customErrors.forEach(item => {
    const error = find(errors, err => err.keyword === item.keyword && err.dataPath === item.dataPath)

    error.message = item.message
  })

  const errorMessage = schema.errorMessage

  for (let i = 0; i < errors.length; i++) {
    const e = errors[i]
    let out
    let n
    let cond
    let path = e.dataPath

    if (e.keyword === 'required') {
      path += '.' + e.params.missingProperty
    }

    if (e.keyword === 'errorMessage' && e.params.errors[0].keyword === 'required') {
      const er = e.params.errors[0]
      path += '.' + er.params.missingProperty
    }

    e.path = path = path.substr(1).replace(regSpit, '.').replace(regIndex, '[$1]')
    const { title } = get(schema, formatPath(path)) || {}
    // const s = schemaPathMap[path]
    // const title = s ? s.title : ''

    if (errorMessage && errorMessage[path]) {
      const msg = errorMessage[path][e.keyword] || errorMessage[path].message

      if (msg) {
        e.message = msg
        continue
      }
    }

    switch (e.keyword) {
      case '$ref':
        out = '无法找到引用' + (e.params.ref)
        break
      case 'additionalItems':
        out = ''
        n = e.params.limit
        out += '不允许超过' + (n) + '个元素'
        break
      case 'additionalProperties':
        out = '不允许有额外的属性'
        break
      case 'anyOf':
        out = '数据应为 anyOf 所指定的其中一个'
        break
      case 'const':
        out = '应当等于常量'
        break
      case 'contains':
        out = '应当包含一个有效项'
        break
      case 'custom':
        out = '应当通过 "' + (e.keyword) + ' 关键词校验"'
        break
      case 'dependencies':
        out = ''
        n = e.params.depsCount
        out += '应当拥有属性' + (e.params.property) + '的依赖属性' + (e.params.deps)
        break
      case 'enum':
        out = '应当是预设定的枚举值之一'
        break
      case 'exclusiveMaximum':
        out = ''
        cond = e.params.comparison + ' ' + e.params.limit
        out += '应当为 ' + (cond)
        break
      case 'exclusiveMinimum':
        out = ''
        cond = e.params.comparison + ' ' + e.params.limit
        out += '应当为 ' + (cond)
        break
      case 'false schema':
        out = '布尔模式出错'
        break
      case 'format':
        out = '应当匹配格式 "' + (e.params.format) + '"'
        break
      case 'formatExclusiveMaximum':
        out = 'formatExclusiveMaximum 应当是布尔值'
        break
      case 'formatExclusiveMinimum':
        out = 'formatExclusiveMinimum 应当是布尔值'
        break
      case 'formatMaximum':
        out = ''
        cond = e.params.comparison + ' ' + e.params.limit
        out += '应当是 ' + (cond)
        break
      case 'formatMinimum':
        out = ''
        cond = e.params.comparison + ' ' + e.params.limit
        out += '应当是 ' + (cond)
        break
      case 'if':
        out = '应当匹配模式 "' + (e.params.failingKeyword) + '" '
        break
      case 'maximum':
        out = ''
        cond = e.params.comparison + ' ' + e.params.limit
        out += '应当为 ' + (cond)
        break
      case 'maxItems':
        out = ''
        n = e.params.limit
        out += '不应多于 ' + (n) + ' 个项'
        break
      case 'maxLength':
        out = ''
        n = e.params.limit
        out += '不应多于 ' + (n) + ' 个字符'
        break
      case 'maxProperties':
        out = ''
        n = e.params.limit
        out += '不应有多于 ' + (n) + ' 个属性'
        break
      case 'minimum':
        out = ''
        cond = e.params.comparison + ' ' + e.params.limit
        out += '应当为 ' + (cond)
        break
      case 'minItems':
        out = ''
        n = e.params.limit
        out += '不应少于 ' + (n) + ' 个项'
        break
      case 'minLength':
        out = ''
        n = e.params.limit
        out += '不应少于 ' + (n) + ' 个字符'
        break
      case 'minProperties':
        out = ''
        n = e.params.limit
        out += '不应有少于 ' + (n) + ' 个属性'
        break
      case 'multipleOf':
        out = '应当是 ' + (e.params.multipleOf) + ' 的整数倍'
        break
      case 'not':
        out = '不应当匹配 "not" schema'
        break
      case 'oneOf':
        out = '只能匹配一个 "oneOf" 中的 schema'
        break
      case 'pattern':
        out = '应当匹配模式 "' + (e.params.pattern) + '"'
        break
      case 'patternRequired':
        out = '应当有属性匹配模式 ' + (e.params.missingPattern)
        break
      case 'propertyNames':
        out = '属性名 \'' + (e.params.propertyName) + '\' 无效'
        break
      case 'required':
        out = `${title || e.params.missingProperty}不能为空`
        break
      case 'switch':
        out = '由于 ' + (e.params.caseIndex) + ' 失败，未通过 "switch" 校验, '
        break
      case 'type':
        out = '应当是 ' + (e.params.type) + ' 类型'
        break
      case 'uniqueItems':
        out = '不应当含有重复项 (第 ' + (e.params.j) + ' 项与第 ' + (e.params.i) + ' 项是重复的)'
        break
      default:
        continue
    }

    e.message = out
  }

  ajv.errors = null
}

function formatPath (path) {
  path = path.replace(regProperties, '.properties$1')
  path = path.replace(regItems, '.items$1')

  return path.substr(1)
}
